<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)"
  [template]="spinnerSrc">
</ngx-spinner>
<router-outlet></router-outlet>